<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">挖矿设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>双矿设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-button
          type="primary"
          size="small"
          @click="handleSync"
          :loading="syncing"
        >
          同步双挖数据
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions } from 'vuex';

export default {
  name: 'MiningDoubleSetting',
  data() {
    return {
      syncing: false
    };
  },
  methods: {
    ...mapActions('miningDouble', ['syncDoubleMiningConfig']),
    handleSync() {
      this.syncing = true;
      this.syncDoubleMiningConfig().then(() => {
        this.$message.success('同步成功！');
        this.syncing = false;
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
